module.exports = __webpack_public_path__ + "components/rewards/vista-tours/static/icon-28c5d76e0ae915be0f8f1f225ff4d929.png";